import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b6897ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "cos-layout-footer"
}

import { computed, getCurrentInstance } from 'vue'
import { layoutTags } from '@dc-platform/dc-interaction'
import type { ComponentInternalInstance } from 'vue'

const __default__ = { name: 'CosLayoutMain' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  streak: Boolean,
  isBreadcrumb: {
    type: Boolean,
    default: true
  }
},
  setup(__props) {

const { slots } = getCurrentInstance() as ComponentInternalInstance

const hasFooterSlot = computed(() => slots?.footer)

const props = __props

const handleClickBreadcrumb = (item: any) => {
  if (item.path) {
    layoutTags.goto(item.path)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_dc_breadcrumb = _resolveComponent("dc-breadcrumb")!
  const _component_dc_layout_button_group = _resolveComponent("dc-layout-button-group")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["cos-layout-main", { 'has-breadcrumb': props.isBreadcrumb }])
    }, [
      (__props.isBreadcrumb)
        ? (_openBlock(), _createBlock(_component_dc_breadcrumb, _mergeProps({ key: 0 }, _ctx.$attrs, { onOnClick: handleClickBreadcrumb }), null, 16))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["cos-layout-main__content", { streak: props.streak }])
      }, [
        _renderSlot(_ctx.$slots, "content")
      ], 2)
    ], 2),
    (hasFooterSlot.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_dc_layout_button_group, null, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "footer")
            ]),
            _: 3
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})